// import Swiper bundle with all modules installed
//import Swiper from 'swiper/bundle';

// import Swiper with navigation bundle
import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade, EffectCreative, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/autoplay';
import 'swiper/scss/pagination';
import 'swiper/scss/navigation';
import 'swiper/scss/virtual';
import PubSub from 'pubsub-js';

// configure Swiper to use modules
//Swiper.use([Navigation, Autoplay]);

// import Swiper styles
//import 'swiper/swiper-bundle.css';

// single slide, centered, autoplay
// not supported in IE11
let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!isIE11) {

    // quotes carousel
    new Swiper('.js-swiper-quotes', {
        modules: reducedMotion.matches ? [Navigation, EffectCreative] : [Navigation, EffectCreative, Autoplay],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 8000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        keyboard: true,
        loop: true,
        speed: 600
    });

    // Hero carousel
    new Swiper('.js-swiper-hero',  {
        // pass EffectSlicer module to modules
        modules: reducedMotion.matches ? [Navigation, EffectCreative] : [Navigation, EffectCreative, Autoplay],
        effect: "creative",
        creativeEffect: {
            prev: {
                translate: [0, 0, -1],
                opacity: 1,
            },
            next: {
                //translate: ["20%", 0, 0],
                scale: 1.4,
                opacity: 0,
            },
        },
        //direction: 'vertical',
        slidesPerView: 1,
        speed: 2000,
        grabCursor: true,
        keyboard: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 8000,
        },
        loop: true
    });

    //setTimeout(() => {
    //    heroSwiper.autoplay.stop();
    //    console.log(heroSwiper);
    //}, 1000);

    PubSub.subscribe('scroll.content', (msg, data) => {
        let heroSwiper = document.querySelector('.js-swiper-hero');
        if (heroSwiper && heroSwiper.swiper?.autoplay) {
            let direction = data?.direction ?? 'down';
            if (direction === 'down' && heroSwiper.swiper.autoplay.running) {
                //console.log('stop');
                heroSwiper.swiper.autoplay.stop();
                //console.log(heroSwiper);
            } else if (direction === 'up' && !heroSwiper.swiper.autoplay.running) {
                //console.log('start');
                heroSwiper.swiper.autoplay.start();
            }
        }
    });

    /*
    new Swiper('.js-swiper-logos',  {
        modules: [Autoplay],
        loop: true,
        loopAdditionalSlides: 0,
        freeMode: true,
        spaceBetween: 0,
        grabCursor: true,
        slidesPerView: 7,
        simulateTouch: false,
        autoplay: {
            delay: 1,
            pauseOnMouseEnter: true,
        },
        speed: 5000,
        freeModeMomentum: false,
    });
     */
}